// extracted by mini-css-extract-plugin
export default {"TitleBar":"TitleBar_BVBDm_v17-8-1","TitleBar_Content":"TitleBar_Content_PIG5__v17-8-1"};